import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, TextField, InputAdornment, Typography, CircularProgress, Box
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from '../../../Axiosinstance';
import Header from '../../Component/Header';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import NewStudent from './NewStudent';

function Student() {
  const [students, setStudents] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    axios.get('/wsq/students/approved')
      .then(response => {
        setStudents(response.data);
        setLoading(false); // Stop loading once data is fetched
      })
      .catch(error => {
        console.error('Error fetching student data:', error);
        setLoading(false);
      });
  }, []);

  // Filter students based on search query
  const filteredStudents = students.filter((studentObj) =>
    studentObj.student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    studentObj.student.nric.toLowerCase().includes(searchQuery.toLowerCase()) ||
    studentObj.student.emailId.toLowerCase().includes(searchQuery.toLowerCase()) ||
    studentObj.student.contactNumber.includes(searchQuery) ||
    studentObj.companyName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handle pagination changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      
      <Paper sx={{ margin: 'auto', padding: 2 }}>
      <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <Typography variant="h5" sx={{ mb: 2 }} align="center">
          Student List
        </Typography>

        {/* Search Bar */}
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Search by Name, NRIC, Email, Contact Number, or Company"
          sx={{ mb: 3 }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* Loader */}
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Table */}
            <TableContainer component={Paper} sx={{ width: '100%', padding: 2 }}>
            <Table aria-label="Company List Table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" sx={{ fontWeight: 'bold', padding: '12px' }}>Name</TableCell>
                    <TableCell align="left" sx={{ fontWeight: 'bold', padding: '12px' }}>NRIC</TableCell>
                    <TableCell align="left" sx={{ fontWeight: 'bold', padding: '12px' }}>Email</TableCell>
                    <TableCell align="left" sx={{ fontWeight: 'bold', padding: '12px' }}>Contact Number</TableCell>
                    <TableCell align="left" sx={{ fontWeight: 'bold', padding: '12px' }}>Company Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredStudents
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((studentObj, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          '&:hover': { backgroundColor: '#f1f1f1' },
                          '& td': { padding: '12px', textAlign: 'left' }
                        }}
                      >
                        <TableCell>{studentObj.student.name}</TableCell>
                        <TableCell>{studentObj.student.nric}</TableCell>
                        <TableCell>
  {studentObj.student.emailId?.map((email, index) => (
    <React.Fragment key={index}>
      {email}
      <br />
    </React.Fragment>
  ))}
</TableCell>
<TableCell>
  {studentObj.student.contactNumber?.map((number, index) => (
    <React.Fragment key={index}>
      {number}
      <br />
    </React.Fragment>
  ))}
</TableCell>
                        <TableCell>{studentObj.companyName}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <TablePagination
              component="div"
              count={filteredStudents.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              sx={{ mt: 2 }}
            />
          </>
        )}
        </div>
      </Paper>
     </>
  );
}

const StudentTab = () => {
  const [tabValue, setTabValue] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleTabChange = (newValue) => {
    setTabValue(newValue);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <Header />
      <br />
      <div className="d-flex justify-content-center mt-4">
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="Students-tabs"
          variant="fullWidth"
          className="d-md-flex justify-content-md-center"
          sx={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            "& button": {
              display: 'flex',
              justifyContent: 'center',
            },
            "& button:hover": {
              backgroundColor: "#eee",
            },
            "& button:active": {
              backgroundColor: "#ddd",
            },
            "& button.Mui-selected": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              display: 'none', // Remove the underline
            },
            ...(isMobile && {
              flexDirection: 'column',
              "& button": {
                width: '100%',
              },
            }),
          }}
        >
          <Tab label="Students" sx={{ minWidth: isMobile ? '50%' : '600px' }} />
          <Tab label="New Students" sx={{ minWidth: isMobile ? '50%' : '600px' }} />
        </Tabs>
        <br />
      </div>
      <div>
        <br/>
        {tabValue === 0 && <Student />}
        {tabValue === 1 && <NewStudent />}
      </div>
    </div>
  );
};

export default StudentTab;
